<template>
    <div>
		<div class="nodea" v-if="data.list.length == 0">
			<img src="../../../../assets/img/nodata.png" >
		</div>
        <div class="list_box" v-for="(item, index) in data.list" @click="goDeatils(i,item.id,item.job_type)" :key="index"
            infinite-scroll-disabled="disabled" v-infinite-scroll="load">
            <div class="two-overflow type_size_22">
                {{item.job_name}}
            </div>
            <div class="p_flex type_size_16 p_m_t_20">
                <span class="subject_color">{{item.classLevel.name}}</span>
                <el-divider direction="vertical"></el-divider>
                <span class="subject_yellow">{{item.subject_def}}</span>
                <el-divider direction="vertical"></el-divider>
                <span>{{item.teacher_name}}</span>
                <el-divider direction="vertical"></el-divider>
                <span>{{item.question_count}}道题</span>
                <el-divider direction="vertical"></el-divider>
                <span>{{item.score}}分</span>
            </div>
            <div class="p_flex p_f_a p_f_b p_m_t_20">
                <div class="p_flex type_size_16">用时{{item.use_minute}}分钟</div>
                <div class="p_flex p_f_a">
                    <span v-show="i == 1" class=" subject_color type_size_22 p_m_r_30">{{item.total_score}}分</span>
                    <el-button type="success" size="mini">查看详情</el-button>
                </div>
            </div>
        </div>
        <!-- <div class="p_flex p_f_c p_m_t_20 p_m_b_20" v-if="loading">加载中...</div>
        <div class="p_m_l_20 p_m_r_20" v-if="noMore">
            <el-divider>没有更多了</el-divider>
        </div> -->
    </div>
</template>

<script>
    export default {
        props: {
            data: {
                type: Object,
                default(){
                    return { list:[], count:0 }
                }
            },
            i: {
                type: Number,
                default () {
                    return 0;
                }
            }
        },
        data() {
            return {
                count: 10,
                loading: false
            };
        },

        computed: {
            noMore() {
                return this.count >= 20;
            },
            disabled() {
                return this.loading || this.noMore;
            }
        },
        mounted() {


        },
        methods: {
            load() {
                this.loading = true;
                setTimeout(() => {
                    this.count += 2;
                    this.loading = false;
                }, 2000);
            },
            goDeatils(i, jobSubmitID,jobType) {
				// this.$router.push({
				//     path: '/AlreadyDeatil',
				//     query: {
				//         type: i,
				//         jobSubmitID,
				//     }
				// });
				if( jobType == 1 ){
					this.$router.push({
					    path: '/AlreadyDeatil',
					    query: {
					        type: i,
					        jobSubmitID,
					    }
					});
				}else{
					this.$router.push({
					    path: '/DeatilSheet',
					    query: {
					        type: i,
					        jobSubmitID,
					    }
					});
				}

            }
        }
    };
</script>

<style lang="scss" scoped>
    .list_box {
        padding: 20px 0;
        border-bottom: 1px solid #e6e6e6;
        margin: 0 20px;
    }

    .type_size_22 {
        line-height: 1.5;
    }
</style>



// WEBPACK FOOTER //
// src/components/homes/already/commponents/alreadyList.vue